import { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { reduxForm } from "redux-form";
import SmartRender from "containers/SmartRender";
import validate from "validations";
import {
  makeSelectFormValues,
  makeSelectReportFraudPayload,
  makeSelectPageValidations,
  makeSelectReportLostFormInitialValues
} from "ducks/selectors";
import { forms } from "utils/constants";
import { submitReplaceSim, changeFormField } from "ducks/actions";
import get from "lodash/get";
import styles from "./styles";

const mapStateToProps = (state, props) =>
  createStructuredSelector({
    styles: () => styles,
    formValues: makeSelectFormValues(forms.REPORT_FRAUD_FORM),
    payload: makeSelectReportFraudPayload(),
    formValidations: makeSelectPageValidations(forms.REPORT_FRAUD_FORM),
    messageData: () => ({
      phoneNumber: get(props, "orderDetails.phone_number"),
      simReplacementFee: get(props, "orderDetails.sim_replacement_fee"),
      address: get(props, "orderDetails.address"),
      stateMessage: get(props, "orderDetails.state_message")
    }),
    initialValues: makeSelectReportLostFormInitialValues()
  });

export const mapDispatchToProps = dispatch => {
  return {
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.REPORT_FRAUD_FORM,
          field: field,
          value: value
        })
      );
    },
    onSubmit: (navigate, payload) => {
      const { skip_form_submission } = payload;
      if (skip_form_submission) {
        navigate();
        return;
      }
      dispatch(
        submitReplaceSim(payload, (result, error) => {
          if (!error) {
            try {
              navigate();
            } catch (err) {
              console.error(
                "Error on submitReplaceSim callback on report fraud actions",
                err
              );
            }
          } else {
            console.error(
              "Error on submitReplaceSim callback on report fraud actions",
              error
            );
          }
        })
      );
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.REPORT_FRAUD_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(SmartRender);
